import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomainsComponent } from './domains.component';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DomainInfoCardComponent } from '../domain-info-card/domain-info-card.component';
import { NewDomainDialogComponent } from '../new-domain-dialog/new-domain-dialog.component';
import { CanAddDomainPipe } from './can-add-domain.pipe';
import { EmailUII18nModule } from '../../../src/lib/i18n/email-ui-i18n.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    GalaxyEmptyStateModule,
    MatIconModule,
    MatButtonModule,
    DomainInfoCardComponent,
    NewDomainDialogComponent,
    EmailUII18nModule,
    TranslateModule,
    CanAddDomainPipe,
    DomainsComponent,
  ],
  exports: [DomainsComponent],
})
export class DomainsModule {}
